export default __webpack_public_path__ + "static/939-44371159697ea0447635e6dbe684091b.gif";